export var actionsRow = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.8em'
};
export var actionBtn = function actionBtn(theme) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5em',
    padding: '0.7em 1.4em',
    fontSize: '1.3rem',
    fontWeight: 500,
    color: theme.gray600,
    backgroundColor: theme.white,
    border: "1px solid ".concat(theme.gray200),
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    '&:hover': {
      color: theme.primary,
      borderColor: theme.primary
    },
    '& i': {
      fontSize: '1.5rem'
    }
  };
};